import { handleActions } from 'redux-actions';
import calendarEmployeeActions from './calendarEmployee-actions';

export default handleActions({
    [calendarEmployeeActions.setCurrentDate]: (state, action) => {
        return {...state, currentDate: action.payload };
    }
},{
    currentDate: null, // Значение по умолчанию перенес в store.js, чтобы у moment выставилась locale
})